import axios, { AxiosResponse } from "axios";
import { Tematica } from "../types/acao";

const API_URL = process.env.REACT_APP_API_URL;

export async function fetchTematicas(): Promise<Tematica[]> {
  const token = sessionStorage.getItem("token");
  if (!token) throw new Error("Token não encontrado");

  const response: AxiosResponse<Tematica[]> = await axios.get(
    `${API_URL}/tematicas`,
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return response.data;
}

export async function fetchTematicasAtivas(): Promise<Tematica[]> {
  const token = sessionStorage.getItem("token");
  if (!token) throw new Error("Token não encontrado");

  const response: AxiosResponse<Tematica[]> = await axios.get(
    `${API_URL}/tematicas/tematicas-ativas
`,
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return response.data;
}

export async function createTematica(
  nome: string,
  ativo: boolean = false,
  ultimo_ano_ativado: number | null = null
): Promise<Tematica> {
  const token = sessionStorage.getItem("token");
  if (!token) throw new Error("Token não encontrado");

  const response: AxiosResponse<Tematica> = await axios.post(
    `${API_URL}/tematicas`,
    { nome: nome.trim(), ativo, ultimo_ano_ativado },
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return response.data;
}

export async function updateTematica(
  id: number,
  data: Partial<Tematica>
): Promise<Tematica> {
  const token = sessionStorage.getItem("token");
  if (!token) throw new Error("Token não encontrado");

  // Buscar a temática antes de atualizar para garantir que nome seja enviado
  const tematicaAtual = await fetchTematicaById(id);

  const response: AxiosResponse<Tematica> = await axios.put(
    `${API_URL}/tematicas/${id}`,
    {
      nome: tematicaAtual.nome, // Garantir que nome seja enviado
      ativo: data.ativo,
      ultimo_ano_ativado: data.ultimo_ano_ativado,
    },
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return response.data;
}

// Criar uma função para buscar a temática pelo ID antes de atualizar
export async function fetchTematicaById(id: number): Promise<Tematica> {
  const token = sessionStorage.getItem("token");
  if (!token) throw new Error("Token não encontrado");

  const response: AxiosResponse<Tematica> = await axios.get(
    `${API_URL}/tematicas/${id}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return response.data;
}
